import { AdminPageShell } from "@/components/shared/admin-page-shell";
import { RoleFormPage } from "@/features/roles/components/RoleFormPage";

export default function RolesNewPage() {
  return (
    <AdminPageShell
      title="إنشاء دور جديد"
      description="أنشئ دوراً مخصصاً يبدأ بصلاحيات المحرر الافتراضية"
    >
      <RoleFormPage />
    </AdminPageShell>
  );
}
